import { createApp } from 'vue'
import './style.css'

import LoanSimulator from './frontend/LoanSimulator.vue'

const app = createApp(LoanSimulator, { displayMode: 'compact' })
app.mount('#loan-simulator')
